import { convertToPhoneNumbers } from "./companyFields";

export interface NewContactFormState {
  firstName: string;
  insertion: string;
  lastName: string;
  emailAddresses: string;
  mobileNumbers: string;
  language: server.dto.LCID;
  position: string;
  addressLine1: string;
  addressLine2: string;
  postalCode: string;
  city: string;
  country: server.dto.Country;
  state: server.dto.State;
  socialSecurity: string;
  tags: server.dto.TagSmall[];
  status: server.dto.StatusSmall;
}

export const getInitialNewContactFormState = (
    serverReference: server.dto.ServerReference,
    userPreference: server.dto.UserPreference,
    statuses: server.dto.StatusSmall[],
): NewContactFormState => {
  const country = serverReference.countries.find(c => c.key === userPreference.regional.country)!;

  return {
    firstName: "",
    insertion: "",
    lastName: "",
    emailAddresses: "",
    mobileNumbers: "",
    language: userPreference.defaults.contactCulture,
    position: "",
    addressLine1: "",
    addressLine2: "",
    postalCode: "",
    city: "",
    country,
    state: country.states.find(s => s.isCountryDefault)!,
    socialSecurity: "",
    tags: [],
    status: statuses[0],
  };
};

export const getCreateContactInstruction = (state: NewContactFormState): server.dto.CreateContactInstruction => ({
  name: {
    firstName: state.firstName,
    insertion: state.insertion,
    lastName: state.lastName,
  },
  emailAddresses: state.emailAddresses,
  mobileNumbers: convertToPhoneNumbers(state.mobileNumbers),
  culture: state.language,
  position: state.position,
  address: {
    addressLine1: state.addressLine1,
    addressLine2: state.addressLine2,
    postalCode: state.postalCode,
    city: state.city,
    stateId: state.state.key,
  },
  socialSecurity: state.socialSecurity,
  tagsIds: state.tags.map(t => t.tagId),
  statusId: state.status.statusId,
});
